'use client';

import * as Sentry from '@sentry/nextjs';
import dynamic from 'next/dynamic';
import { useEffect } from 'react';
export const ErrorPage = dynamic(async () => {
  return (await import('@/components/Error')).ErrorHandle;
}, {
  ssr: false
});
export default function GlobalError({
  error
}: {
  error: Error & {
    digest?: string;
  };
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  return <html data-sentry-component="GlobalError" data-sentry-source-file="global-error.tsx">
      <body>
        {/* `NextError` is the default Next.js error page component. Its type
         definition requires a `statusCode` prop. However, since the App Router
         does not expose status codes for errors, we simply pass 0 to render a
         generic error message. */}
        {/* <NextError statusCode={0} /> */}
        <ErrorPage statusCode={404} data-sentry-element="ErrorPage" data-sentry-source-file="global-error.tsx" />
      </body>
    </html>;
}